"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyButton = void 0;
var _react = require("react");
var _constants = require("../../constants");
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BuyButton = () => {
  const {
    currentProduct: {
      name
    },
    currentShade: {
      canBeReserved,
      canBeSold,
      price,
      productCode
    }
  } = (0, _internal.useProduct)();
  const {
    lineNumber,
    placement
  } = (0, _internal.useAnalyticsData)();
  const {
    originalItemCode,
    originalQuantity
  } = (0, _internal.useSharedConfiguration)();
  const {
    isSubscriptionReplacement
  } = (0, _internal.useReplaceSubscriptionData)();
  const initialQuantity = originalQuantity ?? _constants.PRODUCT_INITIAL_QUANTITY;
  const getOnClickEvent = (0, _hooks.useOnClickEvent)();
  const onClick = (0, _react.useCallback)(newQuantity => {
    window.dispatchEvent(getOnClickEvent(newQuantity));
  }, [getOnClickEvent]);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const buttonContent = (0, _react.useMemo)(() => {
    if (isSubscriptionReplacement) {
      return translations.replace;
    }
    if (originalItemCode) {
      return translations.choose;
    }
    if (canBeReserved) {
      return translations.reserve;
    }
    return translations.buy;
  }, [canBeReserved, isSubscriptionReplacement, originalItemCode, translations.buy, translations.choose, translations.replace, translations.reserve]);
  const disabled = !canBeReserved && !canBeSold;
  // In this case Checkout just replaces the item on specified line number with the new one, quantity is not relevant
  const isShoppingBagItemReplacement = !!originalItemCode && lineNumber != null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BuyButtonComponent, {
    visible: true,
    buyTitle: buttonContent,
    formattedPrice: price.current,
    initialQuantity: initialQuantity,
    productCode: productCode,
    productName: name,
    reserveTitle: "",
    disabled: disabled,
    placement: placement,
    onlyButton: isSubscriptionReplacement || isShoppingBagItemReplacement || disabled,
    loadingEvents: _hooks.loadingEvents,
    onClick: onClick
  });
};
exports.BuyButton = BuyButton;
